module.exports = __webpack_public_path__ + "static/video-test-3-11fd5b24ec3f2479affdced5b595bd25.mp4";